import type { ConsolePageOption, ConsolePageService, Plugin } from '@/plugins'
import { CORE_PLUGIN } from '@/core'
import {
  container,
  injectable,
  instanceCachingFactory,
  registry,
  singleton,
} from 'tsyringe'
import type { App } from 'vue'
import { defineStore } from 'pinia'
import DesignShare from './view/DesignShare.vue'
import DesignShareManage from './view/DesignShareManage.vue'
import ShareDesgin from "./view/ShareDesgin.vue";
import DssCategoriesPage from "./view/DssCategoriesPage.vue";
import { PLUGIN_CONSOLE_PAGE } from '@/plugins/builtin/BuiltinPluginSymbol'

export const productsCategoriesStore = defineStore('categoriesStore', {
  state: () => ({
    menusId: 0
  }),
  getters: {

  },
  actions: {

  },
})
/**
 * 插件的Option定义
 */
@singleton()
@registry([
  {
    token: CORE_PLUGIN,
    useFactory: instanceCachingFactory<Plugin<unknown, unknown>>((c) =>
      c.resolve(DesignSharePagePlugin)
    )
  }
])
@injectable()
export class DesignSharePagePlugin implements Plugin<unknown, unknown> {
  id: string | symbol = ''
  options: unknown
  service: unknown

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  init(app: App<Element>): void {
    app.component("ToShareDesgin", ShareDesgin)
    const plugin =
      container.resolve<Plugin<ConsolePageOption, ConsolePageService>>(
        PLUGIN_CONSOLE_PAGE
      )
    plugin.service.addChildRoute({
      path: 'products/design_share',
      component: DesignShare
    })
    plugin.service.addChildRoute({
      path: 'products/design_share/manage',
      component: DesignShareManage
    })
    plugin.service.addChildRoute({
      path: 'products/design_share/categories',
      component: DssCategoriesPage
    })
    const consolePlugin = container.resolve<Plugin<ConsolePageOption, ConsolePageService>>(PLUGIN_CONSOLE_PAGE)
    consolePlugin.service.addHeadRight("to-share-desgin")
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  initialized(app: App<Element>): void {

  }
}
